import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BookVisitButton, MailButton } from "@/components/contacting/Buttons";
import { PhoneButtonContainer } from "@/components/contacting/Buttons/PhoneButtonContainer";
import { useContactContext, usePlatoAvailable } from "@/contexts/contact";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
import { PhoneCallLegalNotice } from "../Legal/PhoneCallLegalNotice";
const hardfactsContactEntriesTestId = "cdp-hardfacts-contact-entries";
export const HardfactsContactButtons = () => {
    const { t } = useI18n();
    const { phoneNumbers } = useContactContext();
    const avZone = "static";
    const isPlatoAvailable = usePlatoAvailable();
    return (_jsxs(Box, { display: {
            "breakpoint.base": "block",
            "breakpoint.lg": "none",
        }, children: [_jsxs(Box, { display: "flex", gap: "spacing.12", marginBottom: "spacing.12", id: "hardfacts-contact-buttons", children: [_jsx(PhoneButtonContainer, { tracking: { avZone, legacy: "detail-responsive" } }), _jsx(MailButton, { av_zone: avZone, legacyTrackingInfos: "detail-responsive", rootTestId: "test" })] }), isPlatoAvailable && (_jsx(BookVisitButton, { av_zone: avZone, rootTestId: hardfactsContactEntriesTestId, children: t("contact.cta.book_visit") })), phoneNumbers.length !== 0 && _jsx(PhoneCallLegalNotice, {}), _jsx(Divider, { marginVertical: "spacing.16" })] }));
};
